(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('TimingInfo', TimingInfo);

    TimingInfo.$inject = ['$resource', 'DateUtils', 'ENV'];

    function TimingInfo($resource, DateUtils, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/generateTimingInfo';
        var resourceUrl2 = ENV.API_BASE_URL + 'api/getTimingInfoByServiceItems';

        function getTimeSessionDtailByTimeSessionId(timesessionId) {
            var url = ENV.API_BASE_URL + 'api/getTimeSessionDtailByTimeSessionId/' + timesessionId;
            return $resource(url, {}, {});
        }

        function generateTimeSessionsForScheduleUntilDate(scheduleInfoId, untildate) {

            var url = ENV.API_BASE_URL + 'api/generateTimeSessionsForScheduleUntilDate/' + scheduleInfoId + '/' + DateUtils.convertToISOString(untildate);
            return $resource(url, {}, {});
        }

        var generateTimingInfo = $resource(resourceUrl, {}, {});
        var saveScheduleInfo = function () {
            var url = ENV.API_BASE_URL + 'api/schedule-infos';
            return $resource(url, {});
        }
        var addNewTimeSession = function () {
            var url = ENV.API_BASE_URL + 'api/add-new-time-session';
            return $resource(url, {});
        }

        var upsertFloatTimeSession = function () {
            var url = ENV.API_BASE_URL + 'api/upsert-float-time-session';
            return $resource(url, {});

        }
        var computeTimeUnitQty = function () {
            var url = ENV.API_BASE_URL + 'api/client/compute-time-unit-qty-for-timespan';
            return $resource(url, {});
        }
        var saveScheduleInfoForCompany = function () {
            var url = ENV.API_BASE_URL + 'api/company-schedule-infos';
            return $resource(url, {});
        }
        var changeTimeSessionEnable = function (id) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionEnableFlag/' + id;
            return $resource(url, {});
        }
        var updateToSimilarTimeSessions = function (id) {
            var url = ENV.API_BASE_URL + 'api/copy_timesession_to_other_similar_days/' + id;
            return $resource(url, {});
        }
        var changeTimeSessionCapacity = function (sessionid, capacity) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionCapacity/' + sessionid + '/' + capacity;
            return $resource(url, {});
        }
        var changeTimeSessionDiscount = function (sessionid, discount) {
            var url = ENV.API_BASE_URL + 'api/changeTimeSessionDiscount/' + sessionid + '/' + discount;
            return $resource(url, {});
        }
        var getTimingInfoByServiceItems = $resource(resourceUrl2, {}, {});


        var insertServantExceptionDuration = function () {
            var url = ENV.API_BASE_URL + 'api/insert-servant-exception-duration';
            return $resource(url, {});
        }

        var deleteServantExceptionDuration = function () {
            var url = ENV.API_BASE_URL + 'api/delete-servant-exception-duration';
            return $resource(url, {});
        }

        return {
            generateTimingInfo: generateTimingInfo,
            saveScheduleInfo: saveScheduleInfo,
            getTimingInfoByServiceItems: getTimingInfoByServiceItems,
            getTimeSessionDtailByTimeSessionId: getTimeSessionDtailByTimeSessionId,
            generateTimeSessionsForScheduleUntilDate: generateTimeSessionsForScheduleUntilDate,
            changeTimeSessionEnable: changeTimeSessionEnable,
            saveScheduleInfoForCompany: saveScheduleInfoForCompany,
            changeTimeSessionCapacity: changeTimeSessionCapacity,
            changeTimeSessionDiscount: changeTimeSessionDiscount,
            updateToSimilarTimeSessions: updateToSimilarTimeSessions,
            addNewTimeSession: addNewTimeSession,
            computeTimeUnitQty: computeTimeUnitQty,
            upsertFloatTimeSession: upsertFloatTimeSession,
            insertServantExceptionDuration: insertServantExceptionDuration,
            deleteServantExceptionDuration: deleteServantExceptionDuration
        }
            ;
    }
})();
